import { List } from '@hai/ui-react';
import React, { Fragment } from 'react';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { constant } from 'src/js/constant';
import { St2110ViewModel } from './st2110-models';
import { St2110Row } from './st2110-row';
import { useTranslation } from 'react-i18next';
import { NoContentAvailable } from 'src/js/component/no-content-available';

interface St2110Props {
  list: St2110ViewModel[];
  direction: SortDirection;
  onSelect: (model: St2110ViewModel, selected: boolean) => void;
  sorting: string;
  sortInfo: any;
  viewInfo: string[];
  nmosServiceActive: boolean;
}

export const St2110List: React.FunctionComponent<St2110Props> = ({
  list,
  direction,
  onSelect,
  sorting,
  sortInfo,
  viewInfo,
}) => {
  const { t } = useTranslation();
  let count = 0;

  if (viewInfo?.length === 0) {
    return (
      <>
        <NoContentAvailable
          title={t('st2110.noFitleredContent.title')}
          subText={t('st2110.noFitleredContent.subText')}
          iconName="Streams"
          className="h-300-header"
        />
      </>
    );
  }
  return (
    <>
      {[1, 2, 3, 4].map((i) => {
        const itemsShown =
          list && list.filter((l) => l.output === i).filter((l) => viewInfo == null || viewInfo.includes(l.type));
        if (itemsShown && itemsShown.length > 0) {
          count++;
        }
        return (
          <Fragment key={i}>
            {count > 1 && <div className="spacer p20" />}
            {itemsShown && itemsShown.length > 0 && <h4>{t(`st2110.outputs.${i}`)}</h4>}
            <List accentColor={constant.productColor}>
              <SortManager
                sortInfo={sortInfo}
                list={list.filter((l) => l.output === i)}
                sortKey={sorting}
                direction={direction}
                secondLevelSortKey="name"
              >
                {itemsShown &&
                  itemsShown.map((model: St2110ViewModel) => {
                    return <St2110Row key={model.id} model={model} onSelect={onSelect} />;
                  })}
              </SortManager>
            </List>
          </Fragment>
        );
      })}
    </>
  );
};
